/**
 * Localitatea din fereastra de adresa — logica PURA.
 *
 * Fereastra cere intai localitatea (din cele in care piata are zone active,
 * `bootstrap.cities`), apoi strada. Aici stau doar potrivirile de text: cum se
 * recunoaste localitatea unei adrese vechi sau a unui punct de la GPS in lista
 * pietei, si cu ce localitate se porneste. Fara React, ca sa poata fi testate.
 */

/** Fara diacritice, litere mici, fara prefix administrativ („Municipiul X"). */
export function normalizeCityName(value: string | null | undefined): string {
  if (typeof value !== "string") return "";
  return value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim()
    .replace(/^(municipiul|orasul|oras|comuna|satul|sat|localitatea)\s+/i, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/**
 * Localitatea din lista pietei care corespunde textului dat, cu SCRIEREA din
 * lista (cea pe care o cunoaste core-ul), sau `null` cand nu e niciuna.
 * Egalitate pe forma normalizata, apoi includere intr-un sens — furnizorul de
 * geocodare poate scrie „Timisoara" sau „Municipiul Timișoara".
 */
export function matchCity(cities: readonly string[], value: string | null | undefined): string | null {
  const wanted = normalizeCityName(value);
  if (wanted.length === 0) return null;
  const exact = cities.find((city) => normalizeCityName(city) === wanted);
  if (exact !== undefined) return exact;
  const loose = cities.find((city) => {
    const known = normalizeCityName(city);
    return known.length > 0 && (known.includes(wanted) || wanted.includes(known));
  });
  return loose ?? null;
}

/**
 * Cu ce localitate se deschide fereastra:
 *  - piata cu o singura localitate: aceea, fara pas de alegere;
 *  - adresa curenta din sesiune e intr-o localitate a pietei: aceea;
 *  - altfel `null` — clientul alege.
 */
export function pickInitialCity(cities: readonly string[], sessionCity: string | null | undefined): string | null {
  if (cities.length === 1) return cities[0] ?? null;
  if (cities.length === 0) return null;
  return matchCity(cities, sessionCity);
}

/** Pasul de alegere a localitatii exista doar cand e ceva de ales. */
export function needsCityStep(cities: readonly string[], city: string | null): boolean {
  return cities.length > 1 && city === null;
}
